class DetailsModal extends HTMLElement {
	constructor() {
		super();
		this.detailsContainer = this.querySelector('details');
		this.summaryToggle = this.querySelector('summary');
		this.typeSearch = this.classList.contains('header__search');
		this.searchInput = this.querySelector('.search__input')

		this.detailsContainer.addEventListener(
			'keyup',
			(event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
		);
		this.summaryToggle.addEventListener(
			'click',
			(event) => {
				this.onSummaryClick(event);
				this.typeSearch && document.body.classList.add('overflow-hidden', 'overflow-hidden-search');
				setTimeout(() => {
					this.searchInput.focus();
				}, 0);
			}
		);
		this.querySelector('button[type="button"]').addEventListener(
			'click',
			() => {
				this.typeSearch && document.body.classList.remove('overflow-hidden', 'overflow-hidden-search');
				this.close();
			}
		);

		this.summaryToggle.setAttribute('role', 'button');

		this.typeSearch && window.innerWidth < 1200 && this.moveSearch();
	}

	moveSearch() {
		const headerMenuButton = this.closest('.header').querySelector('header-drawer');
		this.classList.add('moved');
		headerMenuButton.insertAdjacentElement('afterend', this);
	}

	isOpen() {
		return this.detailsContainer.hasAttribute('open');
	}

	onSummaryClick(event) {
		event.preventDefault();
		event.target.closest('details').hasAttribute('open')
			? this.close()
			: this.open(event);
	}

	onBodyClick(event) {
		if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
	}

	open(event) {
		this.onBodyClickEvent =
			this.onBodyClickEvent || this.onBodyClick.bind(this);
		event.target.closest('details').setAttribute('open', true);
		document.body.addEventListener('click', this.onBodyClickEvent);
		document.body.classList.add('overflow-hidden');
		this.searchInput.focus();

		// Protection contre la fermeture automatique par le sticky header
		this.recentlyOpened = true;
		setTimeout(() => {
			this.recentlyOpened = false;
		}, 500); // 500ms de protection

		trapFocus(
			this.detailsContainer.querySelector('[tabindex="-1"]'),
			this.detailsContainer.querySelector('input:not([type="hidden"])')
		);
	}

	close(focusToggle = true) {
		// Ne pas fermer si récemment ouvert (protection contre sticky header)
		if (this.recentlyOpened && !focusToggle) {
			return;
		}
		
		removeTrapFocus(focusToggle ? this.summaryToggle : null);
		this.detailsContainer.removeAttribute('open');
		document.body.removeEventListener('click', this.onBodyClickEvent);
		document.body.classList.remove('overflow-hidden');
	}
}

customElements.define('details-modal', DetailsModal);
